export enum MatchOfferDeclineRootCause {    
    IncompletePreSelects = 1,
    DonorNotReady = 2,
    PatientNotReady = 3,
    CadavericKidney = 4,
    SurgicalCapacity = 5,
    Other = 6,
    DonorSurgeon = 7,
    RecipientSurgeon = 8,
    ORUnavailable = 9,
    DonorUnavailable = 10,
    RecipientUnavailable = 11,
    CoordinatorUnavailable = 12,
    NoSuitableRecipient = 13,
    NotNotedDonorAbnormality = 14
}